





































import { mapActions, mapGetters } from 'vuex';

import Vue from 'vue';

export default Vue.extend({
  name: 'LayoutSidebar',
  computed: {
    ...mapGetters('ui', ['sidebarOpen']),
  },
  methods: {
    ...mapActions('ui', ['TOGGLE_SIDEBAR']),
    toggleCollapsed(): void {
      this.TOGGLE_SIDEBAR();
    },
  },
});
